import React from "react";
import { connect } from "react-redux";
import checkJwt from './jwtChecker'
import logout from './logout'

export function requireAuthentication(Component) {
    
    return class AuthenticatedComponent extends React.Component {        
        render() {
            return (
                <div>
                    { checkJwt()
                        ? <Component {...this.props} /> :  logout() }
                </div>
            );
        }
    };
}

const mapStateToProps = state => {
    return {
    };
};
  
const mapDispatchToProps = dispatch => {
    return {
        mapState: (type, data) => dispatch({ type: type, data: data}),
        API: (type, data) => dispatch({ type: type, data: data})
    };
};
  
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(requireAuthentication);
